import React, { useCallback } from "react";
import { Modal } from "../../common/Modal/Modal";
import { PrimaryButton, TitleStyle } from "../../common/common.style";
import { Box, FlexBox } from "../../primitives";

interface ModalUploadHandlerProps {
  setIsModalUploadOpen: (arg1: boolean) => void;
  onClickUploadHandler: () => void;
}

export const ModalUploadHandler = ({
  setIsModalUploadOpen,
  onClickUploadHandler,
}: ModalUploadHandlerProps) => {
  const commonOnConfirm = useCallback(async () => {
    setIsModalUploadOpen(false);
    onClickUploadHandler();
  }, [setIsModalUploadOpen, onClickUploadHandler]);

  const commonOnExit = useCallback(() => {
    setIsModalUploadOpen(false);
  }, [setIsModalUploadOpen]);

  return (
    <Modal onClose={() => commonOnExit()} modalStyle={{ width: 400 }}>
      <TitleStyle>Are you sure you want to upload those cards ?</TitleStyle>
      <FlexBox
        style={{
          marginTop: 20,
          justifyContent: "center",
          alignItems: "center",
          gap: 20,
        }}
      >
        <PrimaryButton
          onClick={() => {
            commonOnConfirm();
          }}
        >
          <Box>CONFIRM</Box>
        </PrimaryButton>
        <PrimaryButton
          onClick={() => {
            commonOnExit();
          }}
        >
          <Box>CLOSE</Box>
        </PrimaryButton>
      </FlexBox>
    </Modal>
  );
};
